@if (isLoading) {
  <div class="loading-overlay">
    <div class="loading-card">

      <img
        src="../img/LOGO.png"
        alt="Fahrenheit"
        class="loading-logo"
      />

      <p class="loading-text">
        {{ message }}
      </p>

    </div>
  </div>
}
